module.exports = __webpack_public_path__ + "static/media/Vector.f7954d6f.svg";